import { Injectable } from '@angular/core';
import { SvgIconRegistryService } from 'angular-svg-icon';

export const SvgIconNames = {
    RoofMShaped: 'roof-m-shaped',
    RoofTypeFlat: 'roof-type-flat',
    RoofTypeHip: 'roof-type-hip',
    RoofTypeIncline: 'roof-type-incline',
    RoofTypePyramid: 'roof-type-pyramid',
    RoofTypeFlatB2B: 'roof-type-flat-b2b',
    RoofTypeOthers: 'roof-type-others',
    RoofTypeMetalWavy: 'roof-type-metal-wavy',
    SingleStoryB2B: 'single-story-b2b',
    DoubleStoryB2B: 'double-story-b2b',
    TripleStoryB2B: 'triple-story-b2b',
    SingleStoryB2C: 'single-story-b2c',
    DoubleStoryB2C: 'double-story-b2c',
    TripleStoryB2C: 'triple-story-b2c',
    HouseTypeSmall: 'house-type-small',
    HouseTypeAverage: 'house-type-average',
    HouseTypeLarge: 'house-type-large',
    ProductSolarPanels: 'product-solar-panels',
    ProductBattery: 'product-battery',
    ProductSolarPanelsAndBattery: 'product-solar-panels-and-battery',
};

@Injectable({
    providedIn: 'root',
})
export class SvgIconWrapperService {
    constructor(private registry: SvgIconRegistryService) {}

    public load(): void {
        Object.values(SvgIconNames).forEach((svgName) => {
            this.registry
                .loadSvg(`assets/svg-loader/${svgName}.svg`, `${svgName}`)
                .subscribe();
        });
    }
}
